import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Title from './Title';
import theme, { largeTitle as titleStyle, sliceColourTheme } from '../styles/theme';
import { richtextType } from '../propTypes/richtext';
import TrayContainer from './TrayContainer';
import {
  getSliceTitleAndTag,
  getSliceCopy,
} from '../selectors';
import { colourThemeType } from '../propTypes';

class TrayModule extends PureComponent {
  renderChildren = () => {
    const {
      classes, title, titleTag, children,
      copy,
    } = this.props;

    return (
      <>
        {title && (
          <Title className={classes.title} tag={titleTag}>
            {title}
          </Title>
        )}
        {copy && (
          // eslint-disable-next-line react/no-danger
          <div className={classes.copy} dangerouslySetInnerHTML={{ __html: copy.html }} />
        )}
        {children}
      </>
    );
  };

  render() {
    const { className, colourTheme } = this.props;

    if (colourTheme.backgroundColour !== sliceColourTheme.white.backgroundColour) {
      return (
        <TrayContainer className={className} colourTheme={colourTheme}>
          {this.renderChildren()}
        </TrayContainer>
      );
    }
    return (
      <div className={className}>
        {this.renderChildren()}
      </div>
    );
  }
}

TrayModule.propTypes = {
  children: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  copy: richtextType,
  // eslint-disable-next-line react/no-unused-prop-types -- used in mapStateToProps
  sliceId: PropTypes.number.isRequired,
  title: PropTypes.string,
  titleTag: PropTypes.string,
  colourTheme: colourThemeType,
};

TrayModule.defaultProps = {
  children: undefined,
  className: undefined,
  copy: undefined,
  title: undefined,
  titleTag: 'h2',
  colourTheme: sliceColourTheme.white,
};

const mapStateToProps = (state, { sliceId }) => ({
  ...getSliceTitleAndTag(state, sliceId),
  copy: getSliceCopy(state, sliceId),
});

export default compose(
  connect(mapStateToProps),

  injectSheet({
    title: {
      ...titleStyle,
      color: ({ colourTheme: { textColour } }) => textColour,
    },
    copy: {
      maxWidth: 608,
      [theme.breakpoints.up(450)]: {
        marginRight: 100,
      },
      [theme.breakpoints.up('md')]: {
        marginRight: 220,
      },
      '& p:last-child': {
        marginBottom: 0,
      },
      'div& p': {
        fontFamily: theme.fonts.body,
      },
      '& p': {
        fontSize: 16,
        lineHeight: 1.5,
      },
      color: ({ colourTheme: { textColour } }) => textColour,
    },
  }),
)(TrayModule);
